import React from 'react'
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next'

import './index.less'
import './mobile.less'

import Layout from '@/components/Layout'
import ContentHeader from '@/components/ContentHeader'
import GetInTouch from '@/components/GetInTouch'
import GoogleMaps from '@/components/GoogleMaps'
import WechatPopover from '@/components/WechatPopover'

import aboutImg from '@/assets/img/contactUs/about.jpg';
import wechatImg from '@/assets/img/icon/wechat.png';
import instagramImg from '@/assets/img/icon/instagram.png';
import facebookImg from '@/assets/img/icon/facebook.png';
import {FACEBOOK_LINK, IG_LINK} from "@/constants";

export default function AboutUs() {
  const {t} = useTranslation()
  
  const commonState = useSelector(state => state.common)
  const rootClassName = commonState.isMobile ? 'contact-us-mobile-container' : 'contact-us-container'
  
  return (
    <Layout isShowFooterTop={false}>
      <div className={rootClassName}>
        {/* <ContentHeader
          className={'contact-us-header-container'}
          des={t('About us')}
          title={t('Our Brand')}
          banner={bannerImg}
        /> */}
        <div className={'contact-us-content-container'}>
          <div className={'contact-us-content-left-container'}>
            <img src={aboutImg} />
          </div>
          <div className={'contact-us-content-right-container'}>
            <div className={'contact-us-content-right-working-hours-container'}>
              <div className={'contact-us-content-right-title'}>{t('About us - Our Brand')}</div>
              <div className={'contact-us-content-right-working-hours-item-container'}>
                <span>{t('Smiling Home was founded in Los Angeles, California in 2012.')}</span>
              </div>
              <div className={'contact-us-content-right-working-hours-item-container'}>
                <span>{t('Since then with a warm heart and dedication, we have successfully provided the market with a series of home linen products, Quilts, Bedspreads, Blankets, Curtains, Sheets, and more! ')}</span>
              </div>
              <div className={'contact-us-content-right-working-hours-item-container'}>
                <span>{t("Smiling Home has achieved a global presence in the Home Decor industry and has become a well-known brand name in our dear customer's hearts.")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
